// Unpublished Work © 2022-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {joinClassNames} from 'Utils/html-utils';

function Status(props) {
    const {
        formattedStatus,
        className
    } = props;

    return (
        <span className={joinClassNames('equipment-status', className)}>
            {formattedStatus}
        </span>
    );
}

Status.propTypes = {
    className: PropTypes.string,
    formattedStatus: PropTypes.string,
    status: PropTypes.string
};

export default Status;
